define(["core/urls",
        "moment",
        "components/custom-domain",
    ],
function(
    urls, 
    moment,
    customDomain
) {
    let nodes = {
        domainSettingsToggles: document.querySelectorAll(".card .settings-toggle-wrap"),
        domainsWrapper: document.querySelector(".domains-wrapper"),
        copyNodes: document.querySelectorAll(".copy-wrap"),
        wrap: document.querySelector(".sidebar_js"),
        closeSideBar: document.querySelectorAll(".close-sidebar_js"),
        menuSteps: document.querySelectorAll(".sidebar-menu-step_js"),
        contentSteps: document.querySelectorAll(".dns-sb-step_js"),
        ohNoBack: document.querySelector(".reset_steps_js"),
        loadingScreen: document.querySelector(".marketing-loader"),
    }

    let toggleIsValid = (id, isValid, errors) => {
        
        let cardStatus = document.querySelector(`.card.domain[data-id="${id}"] .status`);
        let cardMessage = document.querySelector(`.card.domain[data-id="${id}"] .messaging`);
        
        if(isValid) {
            cardStatus.classList.add("valid");
            cardStatus.innerText = "Valid";
            cardMessage.classList.add("hide");
        } else {
            cardStatus.classList.remove("valid");
            cardStatus.innerText = "Invalid";
            cardMessage.classList.remove("hide");

            let errorMessage;

            if(errors && errors.length > 0) {
                errorMessage = `
                    Your domain is invalid due to the following issues: 
                    <ul>
                        ${errors.map(error => `<li>${error}</li>`).join('')}
                    </ul>
                    Please review your DNS settings. If you are unsure about the issue, you can use a webtool to perform an 
                    SPF record lookup (such as <a target="_blank" href="https://mxtoolbox.com/">https://mxtoolbox.com/</a>). This can help with diagnostics. 
                `
            } else {
                errorMessage = `
                    There is an issue with your domain settings. 
                    Please make sure your SPF TXT Record contains a SmileBack reference 
                    and your DKIM TXT Record matches above.
                `
            }

            cardMessage.innerHTML = `
                ${errorMessage}
                <br><br>
                Please note: DNS verification is not always performed instantly. 
                Please wait a few minutes to try again or you can get more information 
                in our <a target="_blank" href="https://docs.connectwise.com/SmileBack/030/020/060">Help Center</a>.
            `;
            
        }
    }

    let createEventListeners = () => {
        // lots of event delegation happening here so newly added domains will have all functionality
        nodes.domainsWrapper.addEventListener("click", (event) => {
            // settings toggle
            if(event.target.parentElement.classList.contains("card-head") || event.target.classList.contains("icon")) {
                let toggle = event.target.parentElement;
                let id = toggle.dataset.id;
                let settings = document.querySelector(`.card[data-id="${id}"] .settings`)
                if(settings.classList.contains("active")) {
                    settings.classList.remove("active");
                } else {
                    settings.classList.add("active");
                }   
            }

            // re-validate buttons
            if(event.target.classList.contains("validate")) {
                nodes.loadingScreen.classList.remove("disabled");
                let id = event.target.dataset.id;
                fetch(urls["configuration:validate-domain"](id), {
                    method: "GET",
                })
                .then(response => {
                    nodes.loadingScreen.classList.add("disabled");
                    return response.json()
                })
                .then((json) => {
                    toggleIsValid(id, json.success, json.errors)
                });
            }

            // copy input text
            if(event.target.classList.contains("copy-wrap")) {
                let parent = event.target.parentElement;
                let value = parent.querySelector("input").value;

                navigator.clipboard.writeText(value).then(() => {
                    event.target.innerText = "Copied!"
                    event.target.classList.add("copied");

                    setTimeout(() => {
                        event.target.innerText = "Copy"
                        event.target.classList.remove("copied");
                    }, 3000)
                });
            }
        })
    }

    return {
        init: function() {
            createEventListeners();
            customDomain.create();
        }
    };
});